import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";

import Modal from "react-modal";
import Pagination from "../../../components/Pagination";
import moment from "moment";

const AttendanceListview = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [docurl, setDocUrl] = useState(false);

  const [AttendanceId, setAttendanceId] = useState(null);

  //

  const { sendRequest: getAttendance } = useHttp();

  const getAllData = () => {
    getAttendance(
      {
        url: `/api/empAttendance/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "12%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "500px",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
   // //console.log(data);

    const warehouseId = data && data.warehouseId;
    const attendanceDate = moment(data && data.attendanceDate).format(
      "DD/MM/YYYY"
    );

    getAttendance(
      {
        url: `/api/empAttendance/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${warehouseId}&attendanceDate=${attendanceDate}`,
      },
      (res) => {
       // //console.log(res);
        setSelectedData(res);
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const Shift = (option) => {
    switch (option) {
      case 1:
        return "First Shift";
      case 2:
        return "Second Shift";
      case 3:
        return "Third Shift";
    }
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Employee Attendance</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Attendance
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>WareHouse</th>
                          <th>Total Present</th>
                          <th>Total Absent</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.attendanceDate}</td>
                                <td>{itm.warehouseName}</td>
                                <td>{itm.presentCount}</td>
                                <td>{itm.absentCount}</td>
                                <td>
                                  {/* <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i> 
                                  </button> */}
                                  <button
                                    onClick={() => openModal(itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i> 
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={modalStyles}>
        {selectedData && (
          <div className="">
            <h4 className="card-title">Employee Attendance Details</h4>
            <div className="card-tools text-right">

              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-4">
                <b>Date:</b> {selectedData[0].attendanceDate}
              </p>
              <p className="col-md-6">
                <b> WareHouse Name:</b> {selectedData[0].warehouseName}
              </p>
            </div>

            <table className="table table-bordered text-center table-sm">
              <thead>
                <tr className="">
                  <th>Sr No</th>
                  <th>Employee Name</th>

                  <th>Attendance Type</th>
                  <th>Shift</th>
                  <th>Attendance</th>
                  <th>In Time</th>
                  <th>Out Time</th>
                  <th>Over Time</th>
                  <th>Total Hours</th>
                </tr>
              </thead>
              <tbody>
                {selectedData &&
                  selectedData.map((itm, i) => {
                    return (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.employeeName}</td>
                        <td>{itm.attendanceType}</td>
                        <td>{Shift(itm.shiftId)}</td>
                        <td>{itm.attendanceStatus ? "Present" : "Absent"}</td>
                        <td>{itm.inTime}</td>
                        <td>{itm.outTime}</td>
                        <td>{itm.overTime}</td>
                        <td>{itm.totalHrs}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AttendanceListview;
